import React, { Component, Fragment } from 'react';
import Modal from 'react-modal';
import customStylesModal from '../../booking/components/CustomStylesModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CardItems from './CardItems';
import FormInvoice from '../forms/FormInvoice';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import styles from '../customStylesRadioButton';
import { connect } from 'react-redux';
import { setInvoiceDataField } from 'components/actions/bookingActions'
import InvoiceCheckbox from './components/InvoiceCheckbox';
import TransHelper from 'components/common/translations/TransHelper';

class Cards extends Component {

  constructor(props, context) {
    super();
    this.state = {
      showModal: false,
      activeKey: null,
      visibleForm: false
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  trans = (key) => {
    return TransHelper.translate(this.props.locale, 'content.account.card.' + key);
  }

  componentDidMount() {
    const { customer } = this.props;
    if (customer.issue_invoice_each_booking && this.invoiceIsEnabled()) {
      this.props.setInvoiceDataField("invoiceCompany", customer.invoice_company);
      this.props.setInvoiceDataField("invoiceAddress", customer.invoice_address);
      this.props.setInvoiceDataField("invoiceTaxNumber", customer.invoice_tax_number);
      this.props.setInvoiceDataField("issueInvoiceEachBooking", customer.issue_invoice_each_booking);
    }
  }

  componentWillUnmount() {
    this.props.resetCardElement();
  }

  handleOpenModal(e) {
    e.preventDefault();
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  handleSelect(activeKey) {
    this.setState({ activeKey });
  }

  resetSelectedCardId = () => {
    this.props.setCardId(null);
  }

  handleChangeInvoiceField = (name, value) => {
    this.props.setInvoiceDataField(name, value);
  }

  handleShowForm = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.setState({ visibleForm: true }, () => {
      this.resetSelectedCardId();
      this.props.createPaymentIntent();
    });
  }

  handleHideForm = () => {
    this.setState({ visibleForm: false });
  }

  invoiceIsEnabled = () => {
    return !this.props.disableInvoice;
  }

  render() {
    const { cardErrors } = this.props;
    return (
      <Fragment>
        <div className="payments-wrap">
          <div className="payments">
            <p className="security">
              <span>
                <FontAwesomeIcon
                  icon={['fas', 'lock']}
                />{this.trans('stripeTitle')}
              </span>
            </p>

            <CardItems
              selectedCardId={this.props.selectedCardId}
              setCardId={this.props.setCardId}
              handleShowForm={this.handleShowForm}
              handleHideForm={this.handleHideForm}
            />

            <div id="stripe-container" style={{display: "none"}} className="form-row">
              <label
                htmlFor="card-element"
                className="no-marg"
              >
                {this.trans('addNewOne')}
              </label>
              <div id="card-element"></div>
              {cardErrors && (
                <div id="card-errors" role="alert">{cardErrors}</div>
              )}
            </div>

            {this.state.visibleForm &&
              <Fragment>
                {this.props.isLogged &&
                  <p className="text-left agree">
                    <label htmlFor="invoice-save-card" className="text-normal no-marg">
                      <Checkbox
                        id="invoice-save-card"
                        checked={this.props.saveCard}
                        onChange={(e) => this.props.onChangeSaveCard()}
                        classes={{
                          root: this.props.classes.root,
                          checked: this.props.classes.checked,
                        }}
                        className="checkbox-button"
                        name="invoice"
                      />
                      {this.trans('saveCard')}
                    </label>
                  </p>
                }
              </Fragment>
            }

          </div>
          {this.invoiceIsEnabled() && (
            <InvoiceCheckbox handleOpenModal={this.handleOpenModal} />
          )}
        </div>

        {this.invoiceIsEnabled() && (
          <Modal
            aria={{
              labelledby: this.trans('invoiceInfo'),
            }}
            closeTimeoutMS={100}
            contentLabel={this.trans('invoiceInfo')}
            isOpen={this.state.showModal}
            onRequestClose={this.handleCloseModal}
            overlayClassName="Overlay"
            style={customStylesModal}
          >

            <div className="md-modal__wrap">
              <div className="md-modal__header">
                <button className="button button--text button--icon button--back" onClick={this.handleCloseModal}>
                  <FontAwesomeIcon
                    icon={['fas', 'angle-left']}
                    size="lg"
                  />
                  {this.trans('invoiceInfo')}
                </button>
              </div>

              <div className="md-modal__content" style={{ padding: '0' }}>
                <div className="md-modal__content-text">
                  <FormInvoice
                    handleChangeField={this.handleChangeInvoiceField}
                    invoiceData={this.props.invoiceData}
                    isInModal
                    closeModal={this.handleCloseModal}
                  />
                </div>
              </div>
            </div>
          </Modal>
        )}

      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLogged: state.app.isLogged,
    invoiceData: state.booking.invoiceData,
    customer: state.auth.customer,
  };
};

export default connect(
  mapStateToProps,
  { setInvoiceDataField }
)(withStyles(styles)(Cards));
